export const AUTH_ROUTES_PATHS = {
  LOGIN: 'login',
  CREATE_ACCOUNT: 'create-account',
} as const;
